import { validator } from "@/utils/validator";
import { MAX_CHARACTER_INPUT_VALIDATION, MAX_INVOICE_SEAL_DISPLAY_NAME_LENGTH } from "@/constants/common";
import { TUserSettingDetail } from "@/api/services/main/user-setting/dtos/get-user-setting.dto";
import { TUpdateUserSettingReqDto } from "@/api/services/main/user-setting/dtos/update-user-setting.dto";
import { INVALID_LIMIT } from "@/constants/invalids";
import { getLeadingNameChars, replaceStr } from "@/utils/string";

export type TUserSettingForm = {
  userFullName: string;
  emailDeliveryOptions: string[];
  invoiceSealDisplayName?: string;
};

export const userSettingSchema = validator.object().shape({
  userFullName: validator.string().required().limit(MAX_CHARACTER_INPUT_VALIDATION).label("表示名"),
  emailDeliveryOptions: validator.array().of(validator.string().required()).default([]).label("通知設定"),
  invoiceSealDisplayName: validator
    .string()
    .max(MAX_INVOICE_SEAL_DISPLAY_NAME_LENGTH, replaceStr(INVALID_LIMIT, { path: "請求書確認押印名", max: MAX_INVOICE_SEAL_DISPLAY_NAME_LENGTH }))
    .label("請求書確認押印名"),
});

/** Seal name to display: the saved value, or the display name's leading characters (max length, whitespace removed) when the user has not set one yet. */
export const getSealDisplayName = (detail?: TUserSettingDetail): string =>
  detail?.invoiceSealDisplayName?.trim() || getLeadingNameChars(detail?.userFullName, MAX_INVOICE_SEAL_DISPLAY_NAME_LENGTH);

export const toUserSettingFormValues = (detail?: TUserSettingDetail): TUserSettingForm => ({
  userFullName: detail?.userFullName ?? "",
  emailDeliveryOptions: detail?.emailDeliveryOptions ?? [],
  invoiceSealDisplayName: getSealDisplayName(detail),
});

export const toUpdateUserSettingPayload = (values: TUserSettingForm): TUpdateUserSettingReqDto => ({
  userFullName: values.userFullName,
  emailDeliveryOptions: values.emailDeliveryOptions,
  invoiceSealDisplayName: values.invoiceSealDisplayName?.trim() ? values.invoiceSealDisplayName.trim() : null,
});
